// SimpleChange-Wrapper für Listen-Inputs — eigene Datei statt Export aus map.component,
// damit andere Komponenten die Klasse ohne Map-Komponenten-Import (und damit ohne Zyklus) nutzen können
import { SimpleChange } from "@angular/core";
import { PAUtil } from "../util";

export class ListsSimpleChange<T> extends SimpleChange {
  //previousValue: T[];
  //currentValue: T[];

  constructor(simple_change: SimpleChange) {
    super(simple_change?.previousValue, simple_change?.currentValue, simple_change?.firstChange || false);
  }

  listValuesChanged(): boolean {
    return !PAUtil.equalSets(new Set(this.previousValue), new Set(this.currentValue));
  }

  getRemovedValues(): T[] {
    const previous_value = this.previousValue || [];
    const current_value = this.currentValue || [];
    return previous_value.filter((value) => !current_value.includes(value));
  }

  getAddedValues(): T[] {
    const previous_value = this.previousValue || [];
    const current_value = this.currentValue || [];
    return current_value.filter((value) => !previous_value.includes(value));
  }
}
